import React from "react";
import { Button, Form, FormControl, InputGroup } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount from "../../../Components/etc/RenderAmount";
import AppTable from "../../Components/AppTable";
import AccountDetails from "../AccountsScreen/AccountDetails";
import _ from "lodash";

const SCREEN_NAME = "REPORTS_SCREEN";

class BalanceSheetInner extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };

    const columns = [
      {
        value: "sl",
        label: "Sl No",
        render: ({ index }) => index,
      },
      {
        value: "account.shortId",
        label: "Account ID",
        render: ({ item }) => (
          <div
            className="hoveredlink"
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "accountDetails",
                modalData: { account: item },
              });
            }}
          >
            {item?.shortId}
          </div>
        ),
      },
      {
        value: "name",
        label: "Name",
        render: ({ item }) => getFullName(item.customer),
      },
      {
        value: "accountType",
        label: "Account Type",
      },
      {
        value: "openingBalance",
        label: "Opening Balance",
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.lastTransaction?.balance || 0}
          />
        ),
      },
      {
        styles: {
          th: { borderLeft: "solid grey" },
          td: { borderLeft: "solid grey" },
        },
        value: "amounts.toLoan",
        label: "Total Loan Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.balanceSheet?.amounts?.toLoan || 0} />
        ),
      },
      {
        value: "amounts.recovery",
        label: "Total Recovery Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.balanceSheet?.amounts?.recovery || 0} />
        ),
      },
      {
        value: "amounts.toInterest",
        label: "Total Interest Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.balanceSheet?.amounts?.toInterest || 0} />
        ),
      },

      {
        styles: {
          th: { borderLeft: "solid grey" },
          td: { borderLeft: "solid grey" },
        },
        value: "amounts.deposit",
        label: "Total Deposit Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.balanceSheet?.amounts?.deposit || 0} />
        ),
      },
      {
        value: "amounts.withdraw",
        label: "Total Withdraw Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.balanceSheet?.amounts?.withdraw || 0} />
        ),
      },
      {
        styles: {
          th: { borderRight: "solid grey" },
          td: { borderRight: "solid grey" },
        },
        value: "amounts.less",
        label: "Total Less Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.balanceSheet?.amounts?.less || 0} />
        ),
      },
      {
        value: "lastInterestTr.amount",
        label: "Last Interest Amount",
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.lastInterestTr?.amount || 0}
          />
        ),
      },
      {
        value: "recoveryAfterLatestInterestTr",
        label: "Recovery After Interest Add",
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.recoveryAfterLatestInterestTr || 0}
          />
        ),
      },

      {
        styles: {
          th: { borderLeft: "solid grey" },
          td: { borderLeft: "solid grey" },
        },
        value: "interestRecovered",
        label: _.startCase("interestRecovered"),
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.interestRecovered || 0}
          />
        ),
      },
      {
        value: "capitalRecovered",
        label: _.startCase("capitalRecovered"),
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.capitalRecovered || 0}
          />
        ),
      },
      {
        styles: {
          th: { borderRight: "solid grey" },
          td: { borderRight: "solid grey" },
        },
        value: "recoveryInterestBalance",
        label: _.startCase("recoveryInterestBalance"),
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.recoveryInterestBalance || 0}
          />
        ),
      },

      {
        value: "outstandingBalance",
        label: "Outstanding Balance",
        render: ({ item }) => (
          <RenderAmount
            value={item?.balanceSheet?.latestTransaction?.balance || 0}
          />
        ),
      },
      {
        value: "currentBalance",
        label: "Current Balance",
        render: ({ item }) => <RenderAmount value={item?.balance || 0} />,
      },
    ];

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });
      const res = await api.get("v1/report/balancesheet", {
        range0,
        range1,
        accountsWhere: this.props.accountsWhere,
      });

      this.setAsyncState({ data: res, loading: false });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  render() {
    const {
      state: { month, year, loading, error, visibleModal, modalData },
      props: { title },
    } = this;

    const content = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">{title || "Balancesheet Report"}</div>
          </div>
          <div className="right">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.onSubmit();
              }}
            >
              <InputGroup className="mb-3">
                <FormControl
                  value={month || ""}
                  onChange={(e) => this.setState({ month: e.target.value })}
                  as="select"
                  required
                >
                  <option value="">Select Month</option>
                  {this.months.map((x, i) => (
                    <option key={i} value={i}>
                      {x}
                    </option>
                  ))}
                </FormControl>
                <FormControl
                  type="number"
                  value={year || ""}
                  onChange={(e) => this.setState({ year: e.target.value })}
                  placeholder="Year"
                  required
                />

                <Button disabled={loading} type="submit">
                  Load
                </Button>
              </InputGroup>
            </Form>
          </div>
        </div>

        <div>
          <AppTable
            {...{
              items: this.state.data?.accounts?.length
                ? [this.state.data?.total || {}, ...this.state.data?.accounts]
                : [],
              loading,
              error,
              table: {
                columns: this.columns,
                getStyle: ({ item }) =>
                  item._id === "total"
                    ? { color: "blue", fontWeight: "bold" }
                    : null,
                // onRowClick: ({ item, index }) =>
                //   this.setAsyncState({
                //     visibleModal: "transactionDetails",
                //     modalData: { transaction: item, index },
                //   }),
              },
            }}
          />
        </div>

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />
      </div>
    );

    return content;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const BalanceSheet = connect(
  mapStateToProps,
  mapDispatchToProps
)(BalanceSheetInner);

export const BalanceSheetLoan = (props) => {
  return (
    <BalanceSheet
      {...{
        title: "Loan Accounts Balancesheet",
        accountsWhere: { accountType: "loan" },
        filteredColumns: [
          "sl",
          "account.shortId",
          "name",
          "openingBalance",
          "amounts.toLoan",
          "amounts.recovery",
          "amounts.toInterest",
          "amounts.less",
          // "lastInterestTr.amount",
          // "recoveryAfterLatestInterestTr",
          "interestRecovered",
          "capitalRecovered",
          "recoveryInterestBalance",
          "outstandingBalance",
          "currentBalance",
        ],
      }}
    />
  );
};

export const BalanceSheetDeposit = (props) => {
  return (
    <BalanceSheet
      {...{
        title: "Deposit Accounts Balancesheet",
        accountsWhere: { accountType: "deposit" },
        filteredColumns: [
          "sl",
          "account.shortId",
          "name",
          "accountType",
          "openingBalance",
          "amounts.deposit",
          "amounts.withdraw",
          "amounts.toInterest",
          "amounts.less",
          "outstandingBalance",
          "currentBalance",
        ],
      }}
    />
  );
};
